import { CustomState } from "@hardware/Store/Reducers";
import setFieldValue from "@hardware/Store/State/CampaignForm/SetFieldValue";
import { CampaignFormContext } from "@hardware/Widgets/CampaignTwoColumn/CampaignForm";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: CustomState) => ({
    firstName: state.campaignForm.fieldValues["firstName"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface FirstNameStyles {
    firstNameTextField?: TextFieldPresentationProps;
}

export const firstNameStyles: FirstNameStyles = {};

const styles = firstNameStyles;

const CampaignFirstName: React.FC<Props> = ({ fields, firstName, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const campaignFormContext = React.useContext(CampaignFormContext);
    const [firstNameErrorMessage, setFirstNameErrorMessage] = React.useState("");

    React.useEffect(() => {
        campaignFormContext.validators.firstName = validateFirstName;
        if (typeof firstName !== "undefined") {
            validateFirstName();
        }
    }, [firstName]);

    React.useEffect(() => {
        campaignFormContext.validators.firstName = validateFirstName;
    }, [isRequired]);

    const validateFirstName = () => {
        const errorMessage = isRequired && !firstName ? (siteMessage("Field_Required", label) as string) : "";
        setFirstNameErrorMessage(errorMessage);
        return !errorMessage;
    };

    const firstNameChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "firstName", value: event.target.value });
    };

    return (
        <TextField
            {...styles.firstNameTextField}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={firstName || ""}
            error={firstNameErrorMessage}
            onChange={firstNameChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CampaignFirstName),
    definition: {
        displayName: "First Name",
        group: "Campaign" as any,
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "First Name",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Jane",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
